// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastData, ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.css'],
  standalone: false
})
export class ToasterComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  showToast = false;
  toastData: ToastData = { type: 'success', message: 'Media Uploaded Successfully!' };
  timeoutRef: any;

  constructor(private toastService: ToastService) { }

  ngOnInit(): void {
    this.toastService.toastState$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(data => {
      this.toastData = data;
      this.showToast = true;

      clearTimeout(this.timeoutRef);
      this.timeoutRef = setTimeout(() => {
        this.showToast = false;
      }, data.duration || 3000);
    });
  }

  close() {
    this.showToast = false;
    clearTimeout(this.timeoutRef);
  }


  get icon(): string {
    switch (this.toastData.type) {
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      case 'info':
        return 'ℹ️';
      default:
        return '';
    }
  }

  get imageAsset(): string {
    switch (this.toastData.type) {
      case 'success': return "assets/images/success-tick-animated.gif";
      case 'error': return 'assets/images/error-animated.gif';
      case 'info': return 'assets/images/info-icon.svg';
      default: return 'assets/images/info-icon.svg';
    }
  }

}
